import { render, staticRenderFns } from "./EventsContestantsFilterWeapons.vue?vue&type=template&id=ea60a0b6&"
import script from "./EventsContestantsFilterWeapons.vue?vue&type=script&lang=ts&"
export * from "./EventsContestantsFilterWeapons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports